module.exports = __webpack_public_path__ + "staticcomp/img/top.4415e96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/3/top.jpg
// module id = TW1K
// module chunks = 39